// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useMemo} from 'react';
import cn from 'classnames';
import {i_card, i_cls_obj} from '../../../../hola/pub/ui/cards';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Menu_cards} from './menu_cards';
import styles from './nav_menu.module.less';
import {use_menu_config} from './nav_utils';

export const Resources_menu = ()=>{
    const {theme} = use_theme({def: 'toolip'});
    const menu = use_menu_config();
    const cards: i_card[] = useMemo(()=>menu?.resources?.items?.map(gi=>({
        ...gi,
        id: gi.id,
        text: gi.sub_title,
        img: <img className={'lazyload'} alt={gi.title}
          data-src={toolip_img_url(gi.icon)}/>,
        clickid: `nav_toolip_products_${gi.id}`,
    })), []);
    const cls: i_cls_obj = {
        container: styles.cards,
        card: styles.card,
        title: cn(theme.monospace, styles.title),
        text: cn(theme.p3, theme.reg, styles.text),
        img: styles.flex_img,
    };
    return <Menu_cards cards={cards} cls={cls}/>;
};
